// Third-party imports
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";

// Internal imports

import { api } from "@/lib/axios";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      await api.post(`/api/auth/logout`);
    },
    onSuccess: () => {
      queryClient.clear();
      navigate({ to: "/login", search: { redirect: "/dashboard" } });
      toast.success("Successfully logged out!");
    },
  });
};
